import {IKeyValue, ITextValue} from '@/interfaces/key-value-interface';

export class KeyValue implements IKeyValue {
  constructor(text, value){
    this.text = text;
    this.value = value;
  }

  text: string;
  value: string;
}

export class KeyValueGeneric<T> implements ITextValue<T> {
  constructor(text, value){
    this.text = text;
    this.value = value;
  }

  text: string;
  value: T;
}
